/**
 * Задержка перед следующей попыткой переподключения:
 * экспоненциальный рост с потолком и джиттером (половина фиксированная,
 * половина случайная), чтобы клиенты не били по серверу синхронно.
 */
export function backoffDelay(attempt, base = 1000, max = 30000, rand = Math.random) {
  const capped = Math.min(base * Math.pow(2, Math.max(0, attempt)), max);
  return Math.round(capped / 2 + rand() * (capped / 2));
}
